// inbox_messages#inbox — the whole page body is the React inbox app.
import { registerPage } from "../first"
import { mountInboxApp } from "../inbox_app"

export const InboxMessagesInboxPage = {
  onDomReady(): void {
    mountInboxApp()
  },
}

registerPage("InboxMessagesInboxPage", InboxMessagesInboxPage)
